/**
 * Debug flag
 *
 * Tells to use some API mock inside javascript code, for example see `AUTH_LOGIN` Vuex action
 * It mostly depends on development mode, but we check used backend, and in case of test
 * environment we disable this flag
 *
 * @type {boolean}
 */
export const debug = process.env.NODE_ENV !== 'production' && !(
  typeof process.env.VUE_APP_TEST_ENVIRONMENT === 'string'
  && process.env.VUE_APP_TEST_ENVIRONMENT.length > 0
);
